import { InjectionToken, Provider } from '@angular/core';
import { ImpersonationApiService } from './impersonation-api.service';
import { ImpersonationRepository } from './impersonation.repository';

export const HTTP_IMPERSONATION_SERVICE = new InjectionToken<ImpersonationRepository>('ImpersonationRepository');

export const IMPERSONATION_API_PROVIDER: Provider = {
    provide: HTTP_IMPERSONATION_SERVICE,
    useClass: ImpersonationApiService,
};
